function resizeWindow(){
	if($(window).width() < 1090){
		//Toggle open/close on tap
		$('#primary-nav li a').click(function(e) {
			if ( $(this).next('.submenu').length > 0 ) {
				e.preventDefault();  
	            $('#primary-nav ul li').removeClass('item-open');
	            $(this).parent().addClass('item-open');
                 
                if(!$(this).next('.submenu').hasClass('menu-open')){
	               $('.submenu.menu-open').slideUp(300, 'easeOutQuart').removeClass('menu-open');
	               $(this).next('.submenu').addClass('menu-open').slideDown(300, 'easeOutQuart'); 
                } else{
	                $(this).next('.submenu').slideUp(300, 'easeOutQuart').removeClass('menu-open');
                } 
            } 
        });
        
        //PDF iframe fancybox
        if($('body.dining').length > 0){
	        $('a.fancybox[data-fancybox-type=iframe]').removeClass('fancybox').attr('target','_blank');
        }
        
        if($(window).width() < 920){
	        $('.top-reasons .reason, .inset-list .item').each(function(){
		        $(this).find('.image').insertBefore($(this).find('.text'));
	        });
        } else{
	        $('.top-reasons .reason, .inset-list .item').each(function(){
		        $(this).find('.image').insertAfter($(this).find('.text'));
	        });
        }
    }
    else{
	    $("#primary-nav li").hover(function(){

	        $(this).addClass("hover");
	        $('ul.submenu',this).fadeIn(200);
	
	    }, function(){
	
	        $(this).removeClass("hover");
	        $('ul.submenu',this).fadeOut(200);
	
	    });
    }
}
function scrollDown(){
	var top = $(document).scrollTop();
	if (top > 50) {
		if(!$('#header').hasClass('down')){
			$('#header').addClass('down');
		}
	} else {
		if($('#header').hasClass('down')){
			$('#header').removeClass('down');
		}
	}
	
	if($('.booking-widget').hasClass('open')){
		$('.booking-widget').removeClass('open').slideUp();
	}	
	
	// if($('body.interactive-map, body.photos').length > 0){
	// 	$('#header').addClass('down');
	// }
	
	if($('body#home').length < 1){
		if($('#top-content').length < 1 || $('#top-content').hasClass('noheader')){
			if(!$('#header').hasClass('down')){
				$('#header').addClass('down');
			}
		}
	}

}

$(document).ready(function () {

	$('p span').each(function() {
	    var text = $(this).text();
	    $(this).text(text.replace('Coste Island Cuisine', 'Cōste Island Cuisine')); 
	});

	//Call function with browser is resized.
    $(window).resize(function (event) {
         resizeWindow();
    });
    //Acts when scroll down page.
    $(window).scroll(function (event) {
    	scrollDown();
	});

    $("#gallery-wrapper").prepend('<h1 class="hidden">Photo Gallery</h1>');
    $("#map-category #content").prepend('<h1 class="hidden">Interactive Map</h1>');
    


	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function(event) {
	    $('body, html').animate({
	        scrollTop: $(window).height()-$('header').outerHeight()*2},
	        800, 'easeOutExpo');
	});
	
	//Remove empty <p> tags created by tinymce
	$('p').each(function() {
	    var $this = $(this);
	    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
	        $this.remove();
	});

	//Event Tracking
	//this class should be add to any link to the booking engine
    $('.book-now').on('click', function () {
         if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
    });
	//this class should be add to the header widget submit button
    $('.bookNow').on('click', function () {
         if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
    });
    //this class should be add to the header widget submit button
    $('.btnLearnmore').on('click', function () {
         if (typeof ga == 'function') ga('send', 'event', 'beach cam learnmore', 'click', 'learn more');
	});
	
	// OpenTable Badge
	$('a.ot-dc-badge.ot-dc-badge--p').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'dining', 'click', 'opentable');
	});
	   
	// Easter Menu
	$('#EasterBuffetMenu').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'dining', 'click', 'easter 2019');
	});
   

	//Check in and check out datepicker for booking engine
	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function( selectedDate ) {
			let getDate = $(this).datepicker('getDate');
        	let newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut" ).datepicker( "setDate", newDate );
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		}
	});
	
	//RFP dates
	// $( "#start_date" ).datepicker({
	// 	changeMonth: true,
	// 	numberOfMonths: 1,
	// 	minDate: 0,
	// 	onSelect: function( selectedDate ) {
	// 		getDate = $(this).datepicker('getDate');
    //     	newDate = new Date(getDate.getTime());
    //     	newDate.setDate(newDate.getDate() + 3);
	// 		$( "#end_date" ).datepicker( "setDate", newDate );
	// 		$( "#end_date" ).datepicker( "option", "minDate", selectedDate );
	// 	}
	// });
	// $( "#end_date" ).datepicker({
	// 	changeMonth: true,
	// 	numberOfMonths: 1,
	// 	onSelect: function( selectedDate ) {
	// 		$( "#start_date" ).datepicker( "option", "maxDate", selectedDate );
	// 	}
	// });
	
	//custom gallery
	$('.custom-gallery a.minis').wrapAll('<div class="wrap"></div>');
	$('.more-gallery').click(function(){
		$(this).css('display', 'none');
		$('.next-gallery').css('display', 'block');
	});
	//forms label
	$('#frmContact .form-entry, #formRFP .field, #job-form .form-entry').each(function(){
		var current = $(this).find('label').html();
		
		if( current.indexOf('<br>') != -1 ){
			current = current.replace('<br>', ' ');
		}
		
		$(this).find('label').next().attr('placeholder', current);
	});
	$('form .btn.btnSubmit').addClass('witharrow');
	
	//btn with arrow
	$('.btn.witharrow').wrapInner('<span></span>');
	$('.btn.witharrow').append($('.nextarrow svg'));
	
	//tel link
	$('.tel').each(function(){
		var newTel = $(this).html().replace(/\D/g,'');
		$(this).attr('href','tel:' + newTel);
	});
	
	//Booking
	$('.book-btn .btn').click(function(){
		$('.booking-widget').addClass('open').slideDown();
	});
	$('.close-booking').click(function(){
		$('.booking-widget').removeClass('open').slideUp();
	});
	
	//bars 
	$('header .bars').click(showMenu);
	
	//suites bottom image
	if($('body.suites').length > 0){
		$('.bottom-content').wrapInner('<div class="container"></div>');
		$('<div class="image"><img src="'+site_url+'assets/images/suites-bottom-img.jpg" alt="Girls playing at the beach"></div>').insertBefore($('.bottom-content .col-md-6'));
	}

	$('form .btn.btnSubmit').click(function(){
	    setTimeout(function(){
		    $('p#thankyou').fadeOut(500);
	    }, 6000);
    });
	
	// Map: Return to previous page button. Change body id to match map template's name.
	$('body.interactive-map #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	$('#video_player').click(function() {
		$('#video_iframe').css('display', 'block');
	});

	
});

$(window).on('load', function(){
	
	resizeWindow();
	scrollDown();
	
   	//Slick Slider
	$('.sym-slides').slick();
	
	$('.slick-dots li button').each(function(){
		if($(this).html() < 10){
			var newText = $(this).html();
			$(this).html('0' + newText);
		}
	});
	
	
	
});

function showMenu(){
	$(this).addClass('open');
	$('#header').addClass('down');
	var wheight = $(window).height() - 120;
	$('header #primary-nav').height(wheight);
	
	if(!$('header #primary-nav').hasClass('open')){
		$('header #primary-nav').wrapInner('<div class="block"></div>');
		$('header #primary-nav').addClass('open');
	}
	
	$('header #primary-nav').fadeIn();
	
	$(this).unbind('click');
	$(this).click(hideMenu);
}
function hideMenu(){
	$(this).removeClass('open');
	
	if ($(document).scrollTop() < 50) {
		$('#header').removeClass('down');
	}
	
	$('header #primary-nav').fadeOut();
	$(this).unbind('click');
	$(this).click(showMenu);
}
function navisEmailSignup(formID) {
	$.post(site_url + 'ajax/emailsignup.php',$("#" + formID).serialize(), function(data){
		if(data.error) {
			if (formID == 'email-signup') {
				$("#email-error2").html(data.msg);
			} else {
				$("#email-error").html(data.msg);
			}

		} else {
			$("#"+formID).html('<p>Thank You</p>');
		}
	},'json');
}

/** ADA - Add aria-label to Header Logo **/
document.addEventListener("DOMContentLoaded", function(){
	const headerLogo = document.querySelector(".header__logo");

	if(headerLogo){
		headerLogo.setAttribute("aria-label", "Diamondhead Beach Resort Logo");
	}
});